import { render } from "./OurSpeciality.vue?vue&type=template&id=d4cd4f5c&scoped=true"
import script from "./OurSpeciality.vue?vue&type=script&lang=js"
export * from "./OurSpeciality.vue?vue&type=script&lang=js"

import "./OurSpeciality.vue?vue&type=style&index=0&id=d4cd4f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4cd4f5c"]])

export default __exports__